<template>
  <div class="barcode-reader" />
</template>

<script>
import Quagga from 'quagga'
export default {
  props: {
    patchSize: {
      type: String,
      default: 'medium'
    }
  },
  mounted() {
    this.start()
  },
  beforeDestroy() {
    if (this.isStarted) {
      this.stop()
    }
  },
  methods: {
    start() {
      Quagga.init(
        {
          inputStream: {
            name: 'Live',
            type: 'LiveStream',
            target: this.$el
          },
          locator: {
            patchSize: this.patchSize
          },
          decoder: {
            readers: ['code_128_reader']
          }
        },
        err => {
          if (err) {
            console.log(err)
            this.isStarted = false
            this.$emit('error', err)
            return
          }
          Quagga.start()
          this.isStarted = true
        }
      )
      Quagga.onDetected(data => {
        if (data && data.codeResult && data.codeResult.code) {
          this.$emit('detected', data)
          Quagga.stop()
          this.isStarted = false
        }
      })
    },
    stop() {
      Quagga.stop()
      this.isStarted = false
    }
  }
}
</script>

<style scoped>
>>> * {
  max-width: 100%;
}
>>> canvas.drawingBuffer {
  position: fixed;
  right: -100vw;
}
</style>
